import { observable, action } from "mobx";
import { error, success } from "../../../../utils/MensagemUtil";
import { Usuario } from "../../../../services";
import { validarCamposObrigatorios } from "../../../../utils/Validate";
import * as CsAvatar from "../../../../constantes/CsAvatars";

class UsuarioStore {
  @observable
  usuario = {
    id: null,
    nome: "",
    email: "",
    login: "",
    senha: "",
    avatar: "",
    confirmacaoSenha: ""
  };

  @observable
  usuarios = [];

  @observable
  avatar = CsAvatar.AVATAR_1;

  @observable
  avatars = CsAvatar.values;

  @observable
  fetching = false;

  reset = () => {
    this.usuario = {
      nome: "",
      email: "",
      login: "",
      senha: "",
      avatar: CsAvatar.AVATAR_1.codigo,
      confirmacaoSenha: ""
    };
  };

  @action.bound
  async filtrar() {
    try {
      this.fetching = true;

      const result = await Usuario.consultar();
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.usuarios = [].concat(result);
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async remover(id) {
    try {
      this.fetching = true;

      const result = await Usuario.excluir(id);
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Usuario excluído com sucesso.");

      this.filtrar();
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async cadastrar(history) {
    try {
      this.fetching = true;

      const erros = this.validarCadastro(this.usuario);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Usuario.cadastrar(this.usuario);
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Usuário cadastrado com sucesso.");
      history.push("/cadastros/usuarios");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.usuario[name] = value;
  };

  @action.bound
  async buscar(id) {
    try {
      this.fetching = true;

      const result = await Usuario.buscar(id);
      if (result && result.erro) {
        this.grupo = {};
        error(result.erro);
        return;
      }

      this.usuario = {
        ...result,
        ativo: `${result.ativo}`,
        senha: "",
        confirmacaoSenha: "",
        avatar: CsAvatar.valueOf(result.avatar)
      };
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async alterar(history) {
    try {
      this.fetching = true;

      const erros = this.validarAlteracao(this.usuario);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      this.usuario.ativo = this.usuario.ativo === "true";

      const result = await Usuario.alterar(this.usuario);
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Usuário alterado com sucesso.");
      history.push("/cadastros/usuarios");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  definirAvatar = target => {
    this.usuario.avatar = target.codigo;
    this.avatar = target;
  };

  validarCadastro = usuario => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Nome", usuario.nome)
      .addSeNuloOuVazio("Login", usuario.login)
      .addSeNuloOuVazio("Senha", usuario.senha)
      .addSeNuloOuVazio("Avatar", usuario.avatar)
      .addSeNuloOuVazio("Confirmação", usuario.confirmacaoSenha);

    if (usuario.senha !== usuario.confirmacaoSenha) {
      erros.addMensagem("As senhas não conferem!");
    }

    return erros.build();
  };

  validarAlteracao = usuario => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Nome", usuario.nome)
      .addSeNuloOuVazio("Login", usuario.login);

    if (usuario.senha) {
      erros.addSeNuloOuVazio("Confirmação", usuario.confirmacaoSenha);
    }

    if (usuario.senha !== usuario.confirmacaoSenha) {
      erros.addMensagem("As senhas não conferem!");
    }
    return erros.build();
  };
}

export default new UsuarioStore();



// WEBPACK FOOTER //
// ./src/views/cadastros/usuarios/stores/UsuarioStore.js